<template>
  <div class="container-help" :style="{ paddingTop: topBarHeight + 'px', ...cssVars() }">
    <van-nav-bar class="van-bar" title="" left-arrow @click-left="handleBack">
      <template #left>
        <img class="left-nav" src="@/assets/packageAssets/common/arrow01.webp" alt="" @click-left="handleBack" />
        <!-- Rules -->
        <span class="tit-left">{{ $t('lang.BaseModule.k075') }}</span>
      </template>
    </van-nav-bar>
    <div class="main">
      <div class="title">
        {{ $t('lang.BaseModule.k021') }}
        {{ $t('lang.SevenKeepSignin.k014') }}
        {{ $t('lang.SevenKeepSignin.k015') }}
      </div>
      <div class="text1">{{ $t('lang.SevenKeepSignin.k004') }}</div>
      <div class="text1">{{ $t('lang.SevenKeepSignin.k005') }}</div>
      <div class="text1">{{ $t('lang.SevenKeepSignin.k006') }}</div>
      <div class="text1">{{ $t('lang.SevenKeepSignin.k007') }}</div>
      <div class="text1">{{ $t('lang.SevenKeepSignin.k008') }}</div>
      <div class="text1">{{ $t('lang.SevenKeepSignin.k009') }}</div>
      <div class="text1">{{ $t('lang.SevenKeepSignin.k010') }}</div>
    </div>
  </div>
</template>

<script>
import { getBaseFeature } from '@/assets/style/variable'

export default {
  components: {},
  props: {},
  data() {
    const query = this.$route.query
    return {
      topBarHeight: query.statusBarHeight || 38,
    }
  },
  methods: {
    cssVars() {
      return { ...getBaseFeature() }
    },
    handleBack() {
      const query = this.$route.query
      if (query.fromPage && query.fromPage === 'seven-keep-signin') {
        this.$router.replace({
          path: '/seven-keep-signin',
          query: {},
        })
      }
      //
      else {
        this.closeWeb()
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.container-help {
  width: 100%;
  min-height: 100vh;
  background: #f9f9fb;
  font-family: var(--string-font), sans-serif;

  ::v-deep .van-nav-bar__left .tit-left {
    font-family: var(--string-font);
    font-size: var(--fs-20);
    font-weight: var(--fw-900);
    line-height: var(--lh-title-24);
    color: #333333;
  }

  .main {
    padding: 20px 16px;
    color: #666666;
    line-height: var(--lh-body-20);
    .title {
      width: 100%;
      margin-bottom: 20px;
      font-family: var(--string-font);
      font-size: var(--fs-16);
      font-weight: var(--fw-700);
      line-height: var(--lh-title-20);
      text-align: center;
      color: #000;
    }
    .text1 {
      width: 100%;
      padding: 0 5px;
      margin-bottom: 10px;
      font-family: var(--string-font);
      font-size: var(--fs-14);
      font-weight: var(--fw-400);
      line-height: var(--lh-body-20);
      color: #333333;
    }
    .text2 {
      width: 100%;
      padding: 0 0 5px 15px;
      font-size: var(--fs-14);
      font-family: var(--string-font);
      font-weight: var(--fw-400);
      line-height: var(--lh-label-16);
      color: #666666;
    }
    i {
      color: #333333;
    }
    .text5 {
      color: #000;
    }
    .table {
      width: 100%;
      background: #ffffff;
      box-shadow: 0px 0px 0px 1px rgba(255, 255, 255, 0.15);
      border-radius: 8px;
      margin: 15px 0;
      border-right: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
      tr {
        display: flex;
        justify-content: space-between;
      }
      td {
        height: 40px;
        border-top: 1px solid #ccc;
        border-left: 1px solid #ccc;
        font-size: var(--fs-12);
        font-family: var(--string-font);
        font-weight: var(--fw-400);
        line-height: var(--lh-display-40);
        color: #333333;
      }
      .level {
        width: 20%;
        text-align: center;
      }
      .rate {
        width: 80%;
        text-align: center;
      }
      .notion {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 80px;
        padding: 13px 16px;
        line-height: var(--lh-body-18);
      }
    }
  }
}
</style>
